/**
 * Fallback route for invalid or incomplete public play links.
 * Never redirect end users to the Horizon app/console from this B2B2C host.
 */
export default function Redirect() {
  return (
    <section className="flex items-center justify-center w-full">
      <div className="text-center px-6">
        <p className="text-lg md:text-xl mb-2">
          The content you are trying to access is not available right now.
        </p>
        <p className="text-sm md:text-base opacity-70">
          Please return to the site or app where you opened this video.
        </p>
      </div>
    </section>
  );
}